import { render, staticRenderFns } from "./NamedRectangleCoordinatableObjectDrawer.vue?vue&type=template&id=a0dcf7be&scoped=true&"
import script from "./NamedRectangleCoordinatableObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./NamedRectangleCoordinatableObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./NamedRectangleCoordinatableObjectDrawer.vue?vue&type=style&index=0&id=a0dcf7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dcf7be",
  null
  
)

export default component.exports